import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { bookService } from "./Nav";

export const Pricing = () => (
    <section id="pricing" data-testid="pricing-section" className="border-y border-ink/10 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 md:px-10">
            <Reveal>
                <p className="flex items-center gap-3 text-xs md:text-sm tracking-[0.25em] uppercase text-ink/50">
                    <span className="h-px w-10 bg-worx inline-block" /> Class pricing
                </p>
            </Reveal>
            <div className="mt-8 grid md:grid-cols-2 gap-px bg-ink/10 border border-ink/10">
                <Reveal>
                    <div className="bg-ink text-paper p-10 md:p-14 h-full" data-testid="pricing-prepay">
                        <p className="text-xs tracking-[0.25em] uppercase text-worx">Prepay online — save $5</p>
                        <div className="mt-4 flex items-baseline gap-3">
                            <span className="font-display font-semibold tracking-tighter text-8xl md:text-9xl leading-none" data-testid="pricing-amount">
                                $95
                            </span>
                            <span className="text-paper/50 text-lg md:text-xl">/ hour</span>
                        </div>
                        <p className="mt-6 text-paper/60 leading-relaxed max-w-md">
                            Secure card payment when you book. Locks in your slot and your savings in one move.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.08}>
                    <div className="bg-white p-10 md:p-14 h-full" data-testid="pricing-later">
                        <p className="text-xs tracking-[0.25em] uppercase text-ink/50">Pay after class</p>
                        <div className="mt-4 flex items-baseline gap-3">
                            <span className="font-display font-semibold tracking-tighter text-8xl md:text-9xl leading-none">
                                $100
                            </span>
                            <span className="text-ink/50 text-lg md:text-xl">/ hour</span>
                        </div>
                        <p className="mt-6 text-ink/60 leading-relaxed max-w-md">
                            Card, CashApp, or cash after your session. Flexible, no prepayment needed.
                        </p>
                    </div>
                </Reveal>
            </div>
            <Reveal delay={0.15}>
                <div className="mt-8 flex flex-wrap items-center justify-between gap-4">
                    <p className="text-ink/60 max-w-md">
                        No packages. No subscriptions. No upsells. One focused hour, one fair price.
                        Websites, apps, and CRM builds are custom-quoted — after a free discovery call.
                    </p>
                    <a
                        href="#booking"
                        onClick={bookService("web-dev")}
                        data-testid="pricing-book-btn"
                        className="inline-flex items-center gap-2 bg-ink text-paper px-8 py-4 font-medium hover:bg-worx transition-colors duration-200"
                    >
                        Book a free dev consult <ArrowUpRight size={16} />
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);
